import { render, staticRenderFns } from "./refundpolicy.vue?vue&type=template&id=d7bf5bd0&scoped=true&"
import script from "./refundpolicy.vue?vue&type=script&lang=js&"
export * from "./refundpolicy.vue?vue&type=script&lang=js&"
import style0 from "./refundpolicy.vue?vue&type=style&index=0&id=d7bf5bd0&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7bf5bd0",
  null
  
)

export default component.exports